import React, { useMemo } from 'react'
import _ from 'lodash'
import classnames from 'classnames/bind'
import { ColorNames } from '../../../constants/colorVars'
import { getCssColorFromColorName } from '../../../utils/colors'
import Icon, { IconProps } from '../icon'
import styles from './styles.scss'

const cx = classnames.bind(styles)

interface MobileRibbonProps {
  title?: string
  backgroundColor?: ColorNames
  iconName?: string
  iconColor?: ColorNames
  icon?: React.FC<IconProps> | React.ReactNode
  className?: string
  darkText?: boolean
}

const MobileRibbon: React.FC<MobileRibbonProps> = ({
  title,
  iconName,
  iconColor,
  icon,
  className,
  darkText = false,
  backgroundColor = ColorNames.Gray,
}) => {
  const backgroundColorRaw = getCssColorFromColorName(backgroundColor)
  const foregroundColorRaw = getCssColorFromColorName(
    darkText ? ColorNames.NearBlack : ColorNames.White
  )

  const colorStyles = useMemo(
    () => ({
      backgroundColor: backgroundColorRaw,
      color: foregroundColorRaw,
    }),
    [backgroundColorRaw, foregroundColorRaw]
  )

  const _icon: React.ReactNode = useMemo(
    () =>
      iconName ? (
        <Icon
          name={iconName}
          color={iconColor || 'inherit'}
          iconStyle='solid'
          fitted
        />
      ) : (
        (icon as React.ReactNode)
      ),
    [iconName, iconColor, icon]
  )

  return (
    <div
      className={cx('ribbon', { 'dark-text': darkText }, className)}
      style={colorStyles}
    >
      {_icon && <div className={cx('icon')}>{_icon}</div>}
      <div>{title}</div>
    </div>
  )
}

export default MobileRibbon
